import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./user/userSlice";
import orderReducer from "./orders/orderSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    order: orderReducer,
  },
});

